import Switch, { SwitchProps }  from '@mui/material/Switch';

/** Renders the toggle swtich control */
const ToggleSwitch = (props: SwitchProps)  => {
    return (
        <Switch
            inputProps={{ 'aria-label': 'primary checkbox' }}
            {...props}
        />
    )
}

export default ToggleSwitch
